"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useDocumentEvent_1 = require("./useDocumentEvent");
var useClickOutside = function (onClose) {
    var containerRef = react_1.useRef(null);
    var callback = react_1.useCallback(function (event) {
        var container = containerRef.current;
        if (container && event.target instanceof Element && !container.contains(event.target)) {
            onClose();
        }
    }, [containerRef, onClose]);
    useDocumentEvent_1.default("click", callback);
    return containerRef;
};
exports.default = useClickOutside;
